module.exports = __webpack_public_path__ + "static/media/sm.f5665000.svg";